
export default class ConnectionType {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionType)) {
            return new ConnectionType(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/connection-types/${this.id}`;
        } else {
            this.path = `/user-site-api/connection-types`;
        }
    }

    listAll() {
        return this.cscom.req.get(this.path, { limit: 9999 }).then((result) => {
            return result._embedded.items;
        });
    }

    getConnectionType(id) {
        return this.cscom.req.get(`/user-site-api/connection-type/${id}`);
    }
    
}
